import React from 'react'
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

const InlineNotification = (props) => {
  // return (
  //   <div className='inline-notification'>
  //     <ReactCSSTransitionGroup
  //       transitionName='coming-from-bottom'
  //       transitionAppear={true}
  //       transitionEnterTimeout={200}
  //       transitionLeaveTimeout={200}
  //       transitionAppearTimeout={200}>
  //       <div key={0} className='inline-notification-wrapper' onClick={props.onClick}>
  //         {props.children}
  //       </div>
  //     </ReactCSSTransitionGroup>
  //   </div>
  // )
  return (
    <div className='inline-notification'>
        <div key={0} className='inline-notification-wrapper' onClick={props.onClick}>
          {props.children}
        </div>
    </div>
  )
}

export default InlineNotification



/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/inline_notification.js
 **/